import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import Select from 'react-select';
import lang from '../../constants/Languages.js';

const SortItems = ({clang, sortOptions, setSortOption, activeSorting}) => {
    const options = sortOptions.map((option, index) => { return {value: option, label:  lang[clang].sort[option], selected: activeSorting === option}});
    const value = options.filter(option => option.selected)[0];

    return (
        <div className="sort-items">
            <Select className="sort-items__select"
                clearable={false}
                deleteRemoves={false}
                backspaceRemoves={false}
                placeholder={lang[clang].results.choose_sorting}
                searchable={false}
                options={options}
                value={value}
                onChange={setSortOption}/>
        </div>
    );
};

SortItems.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SortItems);



// WEBPACK FOOTER //
// ./src/components/sort-items/SortItems.js